<template>
  <div class="courseInformation" :class="props.type == 1 ? 'bg1' : 'bg2'">
    <div class="mask">
      <div class="information_box">
        <div class="top">
          <div class="back">
            <img src="@/assets/img/icon/back_w.png" alt="" @click="router.back()" />
          </div>
          <div class="team">
            <div class="title">{{ props.info.leagueName }}</div>
            <div class="time" v-if="props.info.startAt">
              {{ formatTime(props.info.startAt) }}
            </div>
          </div>
          <!-- 未开始的显示按钮-->

          <div
            class="bottom_box_right"
            @click.stop="reservationHandel"
            v-if="props.info.statusId == 1 && props.info.isBooking == 0"
          >
            预约
          </div>
          <div
            class="bottom_box_right cancellation"
            @click.stop="cancellationBtn"
            v-else-if="props.info.statusId == 1 && props.info.isBooking == 1"
          >
            取消预约
          </div>
          <div style="width: 12.8vw; height: 5.86vw" v-else></div>
        </div>
        <div class="notice" v-if="props.type == 1">
          <div>
            <span v-if="props.info.statusId == 4">下半场 {{ formateTime() }}</span>
            <span v-if="props.info.statusId == 1">未开始</span>
            <span v-if="props.info.statusId == 8">完赛</span>
            <span v-if="props.info.statusId == 9">推迟</span>
            <span v-if="props.info.statusId == 10">中断</span>
            <span v-if="props.info.statusId == 11">腰斩</span>
            <span v-if="props.info.statusId == 12">取消</span>
            <span v-if="props.info.statusId == 13">待定</span>
          </div>
        </div>

        <div class="notice" v-if="props.type == 2">
          <div>
            <span v-if="props.info.statusId == 1">未开始</span>
            <span v-if="props.info.statusId == 2">第一节</span>
            <span v-if="props.info.statusId == 3">第一节完</span>
            <span v-if="props.info.statusId == 4">第二节</span>
            <span v-if="props.info.statusId == 5">第二节完</span>
            <span v-if="props.info.statusId == 6">第三节</span>
            <span v-if="props.info.statusId == 7">第三节完</span>
            <span v-if="props.info.statusId == 8">第四节</span>
            <span v-if="props.info.statusId == 9">加时</span>
            <span v-if="props.info.statusId == 10">完赛</span>
            <span v-if="props.info.statusId == 11">中断</span>
            <span v-if="props.info.statusId == 12">取消</span>
            <span v-if="props.info.statusId == 13">延期</span>
            <span v-if="props.info.statusId == 14">腰斩</span>
            <span v-if="props.info.statusId == 15">待定</span>
          </div>
        </div>
        <div class="pk">
          <div class="pk_msg">
            <img :src="props.info.homeTeamLogo" alt="" v-if="props.info.homeTeamLogo" class="img" />
            <div class="img" v-else></div>

            <h4>{{ props.info.homeTeamName }}</h4>
            <span>主</span>
          </div>
          <div class="pk_m">
            <div v-if="props.info.statusId > 1 && props.info.statusId < 8">
              <div class="score">
                <span>{{ getScore(props.info.currentScore)[0] }}</span>
                <div class="line"></div>
                <span>{{ getScore(props.info.currentScore)[1] }}</span>
              </div>
              <div class="msg">{{ halfFormat() }}</div>
            </div>
            <div v-if="props.info.statusId == 1" class="not_started">
              <p class="not_started_text">距比赛开始</p>
              <p class="not_started_tiem">{{ _timeS }}</p>
            </div>
            <div v-if="props.info.statusId == 8 && props.type == 1" class="result score">
              <span>{{ getScore(props.info.currentScore)[0] }}</span>
              <div class="line"></div>
              <span>{{ getScore(props.info.currentScore)[1] }}</span>
            </div>
            <div v-if="props.info.statusId == 10 && props.type == 2" class="result score">
              <span>{{ getScore(props.info.currentScore)[0] }}</span>
              <div class="line"></div>
              <span>{{ getScore(props.info.currentScore)[1] }}</span>
            </div>
          </div>
          <div class="pk_msg">
            <img :src="props.info.awayTeamLogo" alt="" v-if="props.info.awayTeamLogo" class="img" />
            <div class="img" v-else></div>

            <h4>{{ props.info.awayTeamName }}</h4>
            <span>客</span>
          </div>
        </div>
        <!-- <div class="bottom">
          <div><img src="../../../assets/img/icon/icon4.png" alt="" />动画直播</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup name="courseInformation">
import { computed, ref, onUnmounted, watchEffect, nextTick } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { showConfirmDialog, showToast, showSuccessToast } from "vant";
import { matchAddbooking, matchCancelbooking } from "@/assets/api/match";
import { getScore } from "@/untils/index";

const store = useStore();
const isLogin = ref(localStorage.getItem("isLogin"));
const router = useRouter();
const props = defineProps({
  info: {
    type: Object,
    default: {},
  },
  type: {
    type: Number,
    default: 1,
  },
});
function reservationHandel() {
  if (!isLogin.value) {
    showConfirmDialog({
      title: "提示",
      message: "未登录，是否先登录",
    })
      .then(() => {
        router.push({
          name: "Login",
        });
      })
      .catch(() => {
        // on cancel
      });
    return;
  }
  matchAddbooking({
    matchType: props.type,
    matchId: props.info.id,
  }).then((res) => {
    props.info.isBooking = 1;
    showSuccessToast("预约成功");
  });
}

const halfFormat = () => {
  console.log("00000---000", props.info);
  if (props.type == 1) {
    return "半场" + props.info.halfScore;
  } else {
    if (props.info.statusId > 5) {
      return (
        "半场" +
        (Number(getScore(props.info.q1Score)[0]) +
          Number(getScore(props.info.q2Score)[0]) +
          "-" +
          (Number(getScore(props.info.q1Score)[1]) + Number(getScore(props.info.q2Score)[1])))
      );
    } else {
      return "";
    }
  }
};

const formateTime = () => {
  const now = Math.floor(Date.now() / 1000); // 当前时间戳（秒）
  // const elapsed = Math.floor((now - props.info.currentPeriodStartAt) / 60); // 过去的分钟数
  // 比赛已进行总秒数
  let durationSeconds = now - props.info.currentPeriodStartAt;

  // 如果是下半场，加上45分钟（上半场时长）
  durationSeconds += 45 * 60;

  const mins = String(Math.floor(durationSeconds / 60));
  const secs = String(durationSeconds % 60).padStart(2, "0");
};
function cancellationBtn() {
  if (!isLogin.value) {
    showConfirmDialog({
      title: "提示",
      message: "未登录，是否先登录",
    })
      .then(() => {
        router.push({
          name: "Login",
        });
      })
      .catch(() => {
        // on cancel
      });
    return;
  }
  matchCancelbooking({
    matchType: props.type,
    matchId: props.info.id,
  }).then((res) => {
    props.info.isBooking = 0;
    showSuccessToast("取消成功");
  });
}
function formatTime(time) {
  let date = new Date(time * 1000);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let M = date.getMinutes();
  M = M < 10 ? "0" + M : M;
  let s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  let dateTime = y + "-" + m + "-" + d + " " + h + ":" + m;
  return dateTime;
}

const formatTimeDiff = () => {
  if (props.info.statusId != 1) return;
  let timestamp = props.info.startAt;
  const now = Date.now();

  // 2. 转换时间戳为毫秒（确保正确处理秒级时间戳）
  // 时间戳1752556500是秒级（10位），需要乘以1000转换为毫秒
  const targetTime = timestamp * 1000;

  // 3. 计算时间差（毫秒）
  const diff = Math.abs(targetTime - now);

  // 4. 计算时间单位
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);

  // 5. 补零函数（确保两位数显示）
  const padZero = (num) => num.toString().padStart(2, "0");

  // 5. 返回格式化结果
  // return `${days}天 ${hours}小时 ${minutes}分 ${seconds}秒`;
  _timeS.value = `${days ? days + "天" : ""} ${padZero(hours)}:${padZero(minutes)}:${padZero(
    seconds
  )}`;
};

function formatSeconds() {
  if (props.info.status != 1) return;
  let timeS = props.info.startAt / 1000;
  let result = "";
  let curTime = Date.parse(new Date());
  let time = timeS - curTime / 1000;
  if (time <= 0) {
    result = "00:00:00";
  } else if (time < 60) {
    let s = parseInt(time) < 10 ? "0" + parseInt(time) : parseInt(time);

    result = "00:00:" + s;
  } else if (time < 3600) {
    let m = parseInt(time / 60);
    let s = parseInt(time % 60);

    result = "00:" + (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
  } else if (time < 86400) {
    let h = parseInt(time / 3600);
    let min = time - h * 3600;
    let m = parseInt(min / 60);
    let s = parseInt(min - m * 60);
    result = (h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
  } else if (time > 86400) {
    let day = parseInt(time / 86400);
    let hour = time - day * 86400;
    let h = parseInt(hour / 3600);
    let min = hour - h * 3600;
    let m = parseInt(min / 60);
    let s = parseInt(min - m * 60);

    result =
      day +
      "天  " +
      (h < 10 ? "0" + h : h) +
      ":" +
      (m < 10 ? "0" + m : m) +
      ":" +
      (s < 10 ? "0" + s : s);
  }
  _timeS.value = result;
}
const timer = ref();
const _timeS = ref("");
watchEffect(() => {
  timer.value = setInterval(() => {
    nextTick(() => {
      formatTimeDiff();
    });
  }, 1000);
});
onUnmounted(() => {
  clearInterval(timer.value);
});
</script>
<style scoped>
.courseInformation {
  background-size: 100%;
  height: 58.66vw;
  background-repeat: no-repeat;
  position: relative;
  width: 100%;
}
.bg1 {
  background-image: url("../../../assets/img/home/6.png");
}
.bg2 {
  background-image: url("../../../assets/img/home/7.png");
}
.mask {
  display: flex;
  padding: 6.4vw 3.73vw 7.46vw;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex-shrink: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
}
.back img {
  width: 5.33vw;
  height: 5.33vw;
}
.team {
  padding-left: 5.33vw;
}
.information_box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.top {
  display: flex;
  align-items: center;
  margin-bottom: 4.26vw;
  justify-content: space-between;
}
.bottom_box_right {
  width: 12.8vw;
  height: 5.86vw;
  background-color: #d8ad6d;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: PingFang SC;
  font-size: 2.93vw;
  font-weight: 600;
  border-radius: 4px;
}
.cancellation {
  border: 1px solid #fff;
  background: linear-gradient(180deg, #f9eed7 0%, #fff9ed 100%) !important;

  color: #bc9877 !important;
}
.title {
  color: #fff;
  font-size: 3.46vw;
  font-weight: 600;
}
.time {
  font-size: 2.93vw;
  color: #fff;
  opacity: 0.8;
}

.notice {
  display: flex;
  align-items: center;
  justify-content: center;
}
.notice div {
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.2);
  padding: 3px 6px;
  color: #fff;
  font-size: 3.2vw;
}

.pk {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.pk_msg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
}
.pk_msg .img {
  width: 12.8vw;
  height: 12.8vw;
  object-fit: cover;
  border-radius: 100%;
}
.pk_msg div.img {
  border: 1px solid #fff;
}
.pk_msg h4 {
  color: #fff;
  font-size: 3.46vw;
  font-weight: 400;
  margin: 2px 0;
}
.pk_msg span {
  color: #fff;
  opacity: 0.6;
  font-size: 2.66vw;
}

.pk_m {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.score {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
}
.line {
  width: 2.66vw;
  height: 2.4px;
  flex-shrink: 0;
  background: #fff;
  margin: 0 2.93vw;
}
.score span {
  color: #fff;
  font-size: 6.4vw;
  font-weight: 600;
}

.msg {
  font-size: 2.93vw;
  font-weight: 400;
  color: #fff;
  opacity: 0.8;
}
.not_started {
  font-weight: 600;
  color: #fff;
}
.not_started_text {
  line-height: 4.26vw;

  font-size: 2.93vw;
}
.not_started_tiem {
  font-size: 3.73vw;
}
</style>
